/* eslint-disable no-underscore-dangle */

const waitForDigitalDataClasification = () => {
  return new Promise((resolve) => {
    const checkExist = setInterval(() => {
      const xlpClasification = window?.digitalData?.tag?.XLP_Clasification;
      if (xlpClasification) {
        clearInterval(checkExist);
        resolve();
      }
    }, 300);
  });
};

const getTargetValues = (appCtx) => {
  const digitalDataObject = {
    subSection: window?.digitalData?.page?.subSection,
    subJota: window?.digitalData?.medalliaParameters?.j_sublinea,
    siteSection: window?.digitalData?.page?.subSection,
    store_in_store: appCtx?.store || 'falabella',
    searchTerm:
      window?.__NEXT_DATA__?.props?.pageProps?.searchTerm === 'undefined'
        ? undefined
        : window?.__NEXT_DATA__?.props?.pageProps?.searchTerm,
    jota: window?.digitalData?.medalliaParameters?.j_linea,
    gcategory_a: (window?.digitalData?.tag?.XLP_Clasification ?? '').slice(0, 3),
    gcategory_b: (window?.digitalData?.tag?.XLP_Clasification ?? '').slice(0, 5),
    gcategory_c: (window?.digitalData?.tag?.XLP_Clasification ?? '').slice(0, 7),
    gcategory_d: (window?.digitalData?.tag?.XLP_Clasification ?? '').slice(0, 9),
    emailHash: window?.digitalData?.login?.emailHash,
  };

  const filteredDigitalDataObject = Object.fromEntries(
    Object.entries(digitalDataObject).filter(([, value]) => !!value)
  );
  return filteredDigitalDataObject;
};

export { getTargetValues, waitForDigitalDataClasification };
